import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { type LocalCustomerFieldKey } from '../../../api/types';

const useRenderKYCFieldName = () => {
    const { t } = useTranslation('localCustomerModuleDetails');
    const translationObject = useMemo(() => t('localCustomerModuleDetails:kycFields', { returnObjects: true }), [t]);

    return useCallback(
        (key: LocalCustomerFieldKey) => {
            const foundName = translationObject[key];

            return foundName ?? key;
        },
        [translationObject]
    );
};

export default useRenderKYCFieldName;
